import { createContext, useContext, useEffect, useState } from 'react';
import { fetchPublicSeo } from '../seoData';

const SeoDataContext = createContext({ pagesByPath: null, settings: null, loaded: false });

export const useSeoData = () => useContext(SeoDataContext);

// Fetches /v1/public/seo once on mount and shares it everywhere via context,
// so every <Seo> instance isn't re-fetching on every route change. Failure
// just leaves pagesByPath/settings null — Seo.jsx falls back to the
// hardcoded seoData.js defaults in that case.
export function SeoDataProvider({ children }) {
  const [state, setState] = useState({ pagesByPath: null, settings: null, loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetchPublicSeo()
      .then(({ pagesByPath, settings }) => {
        if (!cancelled) setState({ pagesByPath, settings, loaded: true });
      })
      .catch((err) => {
        console.error('Failed to load SEO settings from API, using static fallback:', err);
        if (!cancelled) setState((prev) => ({ ...prev, loaded: true }));
      });
    return () => { cancelled = true; };
  }, []);

  return <SeoDataContext.Provider value={state}>{children}</SeoDataContext.Provider>;
}
